<template>
  <v-main tag="article">
    <div class="layout-container" :class="classes">
      <slot name="default">
        <transition :name="$route.meta.transition || ''">
          <router-view :key="$route.fullPath + '&' + $store.state.time.current" />
        </transition>
      </slot>
    </div>
  </v-main>
</template>
<script>
export default {
  props: {
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      const result = []
      if (this.fluid === true) {
        result.push('fluid')
      }

      if (this.$route?.meta?.ui?.classes) {
        return result.concat(this.$route.meta.ui.classes)
      }

      return result
    },
  },
}
</script>

<style lang="scss" scoped>
article {
  min-height: calc(var(--vh, 1vh) * 100);
}
</style>
